import { FaClock, FaPlus, FaUser,FaDoorOpen  } from 'react-icons/fa'
import ZynthLogoText from '../../assets/logo-08 (1).png'
import smlogo from '../../assets/smalllogo.png'
import { useNavigate, useLocation } from 'react-router-dom'
import { useState, useEffect, useRef } from 'react'
import { PricingModal } from './PricingModal'
import { Plan } from '../../types/pricingTypes'
import axios from 'axios'
import { IpInfoResponse } from '../../types/authTypes'
import GuidedTour from '../onboarding/shared/GuidedTour'
import GuidedTourMobile from '../onboarding/shared/GuidedTourMobile'
import { Theme } from '../../lib/theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faFileExport } from '@fortawesome/free-solid-svg-icons'
import { useSelector, useDispatch } from 'react-redux'
import { selectPptCount, selectPptLimit, setPptCount, setPptLimit,selectIsEligibleForDownload,setIsEligibleForDownload } from '../../redux/slices/pptSlice';
interface NavbarProps {
  showHistoryId?: boolean // Add a prop to control the "history" ID
  showOrganizationProfileId?: boolean // Add a prop to control the "organization-profile" ID
}

const Navbar: React.FC<NavbarProps> = ({
  showHistoryId,
  showOrganizationProfileId,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [monthlyPlan, setMonthlyPlan] = useState<Plan>()
  const [yearlyPlan, setYearlyPlan] = useState<Plan>()
  const authToken = sessionStorage.getItem('authToken')
  const orgId = sessionStorage.getItem('orgId')
  const [isPricingModalOpen, setIsPricingModalOpen] = useState(false)
  const userProfileImage = sessionStorage.getItem('userDP')
  const [currency, setCurrency] = useState<string>()
  const userProfileRef = useRef<HTMLDivElement | null>(null) // Reference to the profile image to handle click toggles
  const [subId, setSubId] = useState('')
  const navigate = useNavigate()
  // Get current location
  const location = useLocation()
  const [isSmall, setIsSmall] = useState(window.innerWidth < 640);
// In your component:
const pptCount = useSelector(selectPptCount)
const pptLimit = useSelector(selectPptLimit)
const isEligibleForDownload = useSelector(selectIsEligibleForDownload);
const dispatch = useDispatch()
  const handleLogout = () => {
    sessionStorage.clear()
    navigate('/')
  }
  const dropdownRef = useRef<HTMLDivElement | null>(null)
  // Close dropdown when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // Ensure dropdownRef is not null and contains the clicked target
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        userProfileRef.current &&
        !userProfileRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false) // Close dropdown if clicked outside
      }
    }

    // Add event listener to document
    document.addEventListener('mousedown', handleClickOutside)

    // Cleanup the event listener when the component is unmounted or when dropdown state changes
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, []) // Empty dependency array ensures this effect runs once
  

  useEffect(() => {
    const handleResize = () => setIsSmall(window.innerWidth < 640);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // API CALL TO GET PRICING DATA FOR MODAL
  useEffect(() => {
    const getPricingData = async () => {
      const ipInfoResponse = await fetch(
        'https://api.zynth.ai/api/v1/data/userprofile/ip-info'
      )
      const ipInfoData: IpInfoResponse = await ipInfoResponse.json()

      await axios
        .get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/payments/razorpay/plans`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        )
        .then((response) => {
          const country = ipInfoData!.country!

          if (country !== 'IN' && country !== 'India' && country !== 'In') {
            setMonthlyPlan(response.data.items[4])
            setYearlyPlan(response.data.items[2])
            // setMonthlyPlan(response.data.items[1])
            // setYearlyPlan(response.data.items[0])
            setCurrency('USD')
          } else if (
            country === 'IN' ||
            country === 'India' ||
            country === 'In'
          ) {
            setMonthlyPlan(response.data.items[5])
            setYearlyPlan(response.data.items[3])
            // setMonthlyPlan(response.data.items[1])
            // setYearlyPlan(response.data.items[0])
            setCurrency('INR')
          }
        })
    }

    const fetchUserPlan = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        )
        const subscriptionId = response.data.plan.subscriptionId
        setSubId(subscriptionId)
      } catch (error) {
        console.error('Error fetching user plan:', error)
      }
    }

    fetchUserPlan()

    const timer = setTimeout(() => {
      getPricingData()
    }, 3000) // delay

    // Cleanup the timer in case the component unmounts
    return () => clearTimeout(timer)
  }, [])
  const monthlyPlanAmount = monthlyPlan?.item.amount! / 100
  const monthlyPlanId = monthlyPlan?.id
  const yearlyPlanAmount = yearlyPlan?.item.amount! / 100
  const yearlyPlanId = yearlyPlan?.id

  const toggleDropdown = () => {
    setDropdownOpen((prevState) => !prevState) // Toggle dropdown state
  }

  // Ensures cross-origin file downloads work reliably by fetching the file
  // and triggering a client-side download using a Blob URL.
  const pdfUrl = 'https://zynthimages.s3.us-east-1.amazonaws.com/pdf/The_Orca_Blueprint.pdf'
  const handleDownload = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Prevent navigation so we can control the download behavior
    e.preventDefault()

    if (!isEligibleForDownload) {
      return
    }

    try {
      const response = await fetch(pdfUrl, { mode: 'cors' })
      if (!response.ok) {
        throw new Error(`Failed to fetch file: ${response.status}`)
      }
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'The_Orca_Blueprint_Letter_21.pdf'
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)
    } catch (err) {
      console.error('Download failed:', err)
      // Fallback: if fetch fails, attempt normal navigation to the file
      window.open(pdfUrl, '_blank')
    }
  }

  return (
    <nav className="bg-white p-2 lg:p-3">
      <div className="w-full mx-auto flex items-center justify-between md:justify-between lg:justify-between">
        {/* Logo */}
        <a
          className="transition-all duration-300 transform hover:scale-110 active:scale-95 active:opacity-80"
          href="/"
          target="_blank"
        >
          {!isSmall ? (<img src={ZynthLogoText} alt="Logo Text" className="h-8" />):(
            <img src={smlogo} alt="Logo Text" className="h-10 w-18 ml-4" />
          )}
          
        </a>

        {/* Menu */}
        <div className="flex items-center space-x-4">
          {/* Conditionally hide the "New Presentation" button on '/new-presentation' */}
          {location.pathname !== '/new-presentation' && (
          <button
  onClick={() => navigate('/new-presentation')}
  className="lg:h-[2.5rem] text-base font-medium px-4 py-4 lg:py-2 rounded-md active:scale-95 transition transform duration-300 border"
  style={{
    backgroundColor: Theme.colors.primary,
    borderColor: Theme.colors.primary,
    color: Theme.colors.background,
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = Theme.colors.background;
    e.currentTarget.style.color = Theme.colors.primary;
    e.currentTarget.style.borderColor = Theme.colors.primary;
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = Theme.colors.primary;
    e.currentTarget.style.color = Theme.colors.background;
    e.currentTarget.style.borderColor = Theme.colors.primary;
  }}
>
           <span className="sm:hidden text-base">
             <FaPlus />
           </span>
           <span className="hidden sm:flex items-center space-x-2">
             <FaPlus />
             <span>New Presentation</span>
           </span>
         </button>
          )}
          

    {location.pathname !== '/investor-dashboard' && (  
     <button
       type="button"
  onClick={() => navigate('/investor-dashboard')}
  className={`lg:h-[2.5rem] text-base font-medium px-4 py-4 lg:py-2 rounded-md active:scale-95 transition transform duration-300 border ${!isEligibleForDownload ? 'opacity-50 cursor-not-allowed' : ''}`}
  disabled={!isEligibleForDownload}   
  style={{
    backgroundColor: Theme.colors.background,
    color: Theme.colors.primary,
    borderColor: Theme.colors.primary,
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = Theme.colors.primary;
    e.currentTarget.style.color = Theme.colors.background;
    e.currentTarget.style.borderColor = Theme.colors.primary;
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = Theme.colors.background;
    e.currentTarget.style.color = Theme.colors.primary;
    e.currentTarget.style.borderColor = Theme.colors.primary;
  }}
>
            <span className="sm:hidden text-base">
              <FaDoorOpen  />
            </span>
            <span className="hidden sm:flex items-center space-x-2">
              <FaDoorOpen  />
              <span>Investor Portal</span>
            </span>
            
          </button>
          )}     
                  
<a
  href={pdfUrl}
  className={`lg:h-[2.5rem] text-base font-medium px-4 py-4 lg:py-2 rounded-md active:scale-95 transition transform duration-300 border flex items-center justify-center space-x-2 ${!isEligibleForDownload ? 'opacity-50 cursor-not-allowed' : ''}`}
  style={{
    backgroundColor: Theme.colors.background,
    color: Theme.colors.primary,
    borderColor: Theme.colors.primary,
    textDecoration: 'none',
  }}
  onMouseEnter={(e) => {
    (e.currentTarget as HTMLAnchorElement).style.backgroundColor = Theme.colors.primary;
    (e.currentTarget as HTMLAnchorElement).style.color = Theme.colors.background;
  }}
  onMouseLeave={(e) => {
    (e.currentTarget as HTMLAnchorElement).style.backgroundColor = Theme.colors.background;
    (e.currentTarget as HTMLAnchorElement).style.color = Theme.colors.primary;
  }}
  onClick={handleDownload}
  role="button"
  aria-disabled={!isEligibleForDownload}
>
  <FontAwesomeIcon icon={faDownload} />
  <span className="hidden sm:inline">The Orca Blueprint</span>
</a>

  

 <button
  id={showHistoryId ? 'history' : undefined}
  onClick={() => navigate('/history')}
  className="lg:h-[2.5rem] text-base font-medium px-4 py-4 lg:py-2 rounded-md active:scale-95 transition transform duration-300 border"
  style={{
    backgroundColor: Theme.colors.background,
    color: Theme.colors.primary,
    borderColor: Theme.colors.primary,
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = Theme.colors.primary;
    e.currentTarget.style.color = Theme.colors.background;
    e.currentTarget.style.borderColor = Theme.colors.primary;
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = Theme.colors.background;
    e.currentTarget.style.color = Theme.colors.primary;
    e.currentTarget.style.borderColor = Theme.colors.primary;
  }}
>
            <span className="sm:hidden text-base">
              <FaClock />
            </span>
            <span className="hidden sm:flex items-center space-x-2">
              <FaClock />
              <span>History</span>
            </span>
            
          </button>
          {/* User Profile Icon */}
          <div
            id={showOrganizationProfileId ? 'organization-profile' : undefined} // Conditionally apply the ID
            ref={userProfileRef}
          >
            {userProfileImage ? (
              <img
                src={userProfileImage}
                alt="User Profile"
                className="w-11 h-11 lg:w-11 lg:h-11 rounded-full hover:scale-105 cursor-pointer"
                onClick={toggleDropdown} // Toggle dropdown when clicked
              />
            ) : (
              <FaUser
                className="w-11 h-11 lg:w-10 lg:h-10 rounded-full hover:scale-105 cursor-pointer"
                onClick={toggleDropdown} // Toggle dropdown when clicked
              />
            )}
          </div>
          {/* Dropdown */}
          {dropdownOpen && (
        <div
  ref={dropdownRef}
  className="fixed top-20 lg:top-17 right-2 lg:right-4 shadow-lg rounded-md p-2 z-50 w-48 h-auto"
  style={{
    backgroundColor: Theme.colors.background, // dynamic background
  }}
  onClick={() => setDropdownOpen(false)}
>
     <button
  onClick={() => navigate('/organization-profile')}
  className="w-full text-left text-sm py-1 px-4 overflow-hidden text-ellipsis whitespace-nowrap"
  style={{
    color: Theme.colors.text.weak,                   // replaces text-[#5D5F61]
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = Theme.colors.stroke.weak; // replaces hover:bg-gray-100
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = 'transparent';
  }}
>
                Organization Profile
              </button>
       {/* <button
  onClick={() => setIsPricingModalOpen(true)}
  className="w-full text-left text-sm py-1 px-4 overflow-hidden text-ellipsis whitespace-nowrap"
  style={{
    color: Theme.colors.text.weak, // replaces text-[#5D5F61]
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = Theme.colors.stroke.weak; // replaces hover:bg-gray-100
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = 'transparent';
  }}
>
                Subscription Plans
              </button>
       <button
  onClick={() => navigate('/refer')}
  className="w-full text-left text-sm py-1 px-4 overflow-hidden text-ellipsis whitespace-nowrap"
  style={{
    color: Theme.colors.text.weak, // replaces text-[#5D5F61]
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = Theme.colors.stroke.weak; // replaces hover:bg-gray-100
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = 'transparent';
  }}
>
                Refer & Earn
              </button> */}
<button
  className="w-full text-left text-sm py-1 px-4 overflow-hidden text-ellipsis whitespace-nowrap"
  style={{
    color: Theme.colors.text.weak, // replaces text-[#5D5F61]
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = Theme.colors.stroke.weak; // replaces hover:bg-gray-100
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = 'transparent';
  }}
  onClick={handleLogout}
>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Pricing Modal */}
      {isPricingModalOpen && (
        <PricingModal
          closeModal={() => setIsPricingModalOpen(false)}
          heading="Subscription Plans"
          monthlyPlanAmount={monthlyPlanAmount}
          yearlyPlanAmount={yearlyPlanAmount}
          subscriptionId={subId}
          currency={currency!}
          yearlyPlanId={yearlyPlanId!}
          monthlyPlanId={monthlyPlanId!}
          authToken={authToken!}
          orgId={orgId!}
        />
      )}
      <GuidedTour />
      <GuidedTourMobile />
    </nav>
  )
}

export default Navbar
